import { ETheme } from "@/DependenciesV9";
import { NavCategory, NavCategoryProps } from "@fluentui/react-nav-preview";

interface NavCategoryCustomProps extends NavCategoryProps {
  rcName?: string;
  theme?: ETheme;
}

const NavCategoryCustom = (props: NavCategoryProps & NavCategoryCustomProps) => {
  return <NavCategory {...props}/>
};

export default NavCategoryCustom;